import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
	rowContainer: {
		display: 'flex',
		borderBottom: `1px solid ${theme.other.getColor('border/secondary/default')}`,
		padding: theme.spacing.sm,
		cursor: 'pointer',
		':hover': {
			backgroundColor: theme.other.getColor('fill/primary/hover'),
		},
	},
	resourceColumn: {
		color: theme.other.getColor('text/secondary/default'),
		fontSize: theme.fontSizes.xs,
		flex: '0 0 50%',
		minWidth: 0,
		display: 'flex',
		justifyContent: 'space-between',
	},
	conditionsColumn: {
		color: theme.other.getColor('text/secondary/default'),
		fontSize: theme.fontSizes.xs,
		flex: '0 0 20%',
		minWidth: 0,
		alignItems: 'center',
	},
	statusColumn: {
		color: theme.other.getColor('text/secondary/default'),
		fontSize: theme.fontSizes.xs,
		flex: '0 0 15%',
		minWidth: 0,
		alignItems: 'center',
	},
	scoreColumn: {
		color: theme.other.getColor('text/secondary/default'),
		fontSize: theme.fontSizes.xs,
		flex: '0 0 15%',
		minWidth: 0,
		alignItems: 'flex-end',
	},
	dateColumn: {
		color: theme.other.getColor('text/secondary/default'),
		fontSize: theme.fontSizes.xs,
		flex: '0 0 15%',
		minWidth: 0,
		alignItems: 'center',
	},
	columnColumn: {
		flex: '0 0 25%',
	},
	piiColumn: {
		flex: '0 0 20%',
	},
	sampleDataColumn: {
		flex: '0 0 15%',
	},
	columnTable: {
		width: '100%',
	},
	columnHeader: {
		width: '100%',
		background: theme.other.getColor('surface/primary/active'),
	},
	badge: {
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		'& > span': {
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},
	},
	resolveText: {
		color: theme.other.getColor('text/secondary/default'),
		fontSize: theme.fontSizes.xs,
		alignSelf: 'center',
		paddingRight: theme.spacing.lg,
	},
}));
